module.exports = __webpack_public_path__ + "img/C6.6190c800.png";